export enum TiFeatures {
  PleaseReview = 'pleasereview',
  Alfresco = 'alfresco',
  OCR = 'ocr',
  Flashviewer = 'flashviewer',
  JasperReports = 'jasperreports',
  eSignature = 'esignature',
  IrbIntegration = 'irbintegration',
  CtmsIntegration = 'ctmsintegration',
  LMSIntegration = 'lmsintegration',
  EventManagement = 'eventmanagement',
  Original = 'native',
  TiViewer = 'tiviewer',
  SnowboundViewer = 'snowboundviewer',
  INCIntegrationNewDataRoomEvent = 'incintegration.newdataroomevent',
  TIAnalytics = 'tianalytics',
}
